<div class="platform-footer-container">
  @if (isPublic) {
    @for (link of footerLinks | async; track $index) {
      <a [href]="link.href" target="_blank" rel="noopener">
        {{ link.text }}
      </a>
    }
  } @else {
    @for (link of footerLinks | async; track $index) {
      @if (link.isCookieButton) {
        <a [attr.data-cy]="link.key" (click)="toggleCookieSettings()">{{
          link.label
        }}</a>
      }
      @if (link.routerLink) {
        @if (isDefault) {
          <a rel="noopener" [href]="link.href" [attr.data-cy]="link.key">{{
            link.label
          }}</a>
        } @else {
          <a
            [routerLink]="[link.routerLink]"
            [queryParams]="{ pageId: link.pageId }"
            [attr.data-cy]="link.key"
            >{{ link.label }}</a
          >
        }
      }
    }
  }
</div>
